'use strict';
import globals from './lib/globals';
import ThemeFlexibleContent from './partials/themeFlexibleContent';
import ThemeImageGrid from './partials/themeImageGrid';
import Logger from "./utilities/Logger";

// Bootstrap global functionality
globals();

const NAME = 'ORIGINALS';
Logger.log(NAME);
const bdy  = document.body;
const main = document.getElementsByTagName('main')[0];

// Initialize the Flexible Content sections

// Gather all themeFlexibleContents
const themeFlexibleContents = document.querySelectorAll('[data-theme-flexible-content]');
themeFlexibleContents.forEach((dom) => {
	const themeFlexibleContent = new ThemeFlexibleContent(
		dom
	);
});

// Create the ThemeImageGrid
const imageGridDom = document.querySelector('[data-theme-image-grid]');
const imageGrid = new ThemeImageGrid(imageGridDom);
imageGrid.init();
